import { VariationDataType } from '@featbit/js-client-sdk';

import { initFeatbit } from '@sternum/shared-utils/feature-flags/featbit/browser';
import { Config } from '@sternum/web/config';
import { sternumWebFFConfig } from '@sternum/web/config/featureFlags';

import { WithFeatbitProvider } from './FeatbitProvider';

const { featbitClient } = await initFeatbit({
  sdkKey: Config.featbit.secretKey,
  streamingUri: Config.featbit.streamingUri,
  eventsUri: Config.featbit.eventsUri,
  userKeyId: Config.featbit.userKeyId,
});

export const FeatureFlagsProvider = await WithFeatbitProvider({
  client: featbitClient,
  bootstrap: Object.entries(sternumWebFFConfig).map(([flag, config]) => ({
    id: flag,
    variation: config.default,
    variationType: config.type as VariationDataType,
  })),
});
